import React, { Component } from "react";
import { withRouter } from "../utils/withRouter";
import { Modal } from 'antd';
import api from "../api/index";
import { Link } from "react-router-dom";
import fulllogo from "../assets/images/spare_logo_full.png";

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      isSubmitting: false,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ isSubmitting: true});
    if(this.state.email){
        this.setState({
            isSubmitting: false,
        });
    }
    fetch(`${api.main}api/auth/forgot_password`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: this.state.email }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Unable to send reset link. Please try again.");
        return res.json();
      })
      .then((data) => {
        if(data.success){
          Modal.success({
            title: 'Success!',
            content: "You should receive an email to reset your password shortly."
          })
          this.setState({
            isSubmitting: false,
          });
        }
        else{
          Modal.error({
            title: 'Invalid',
            content: data.message || 'Failed to send link. Please try again.',
          });
        }
      })
      .catch((err) => {
          Modal.error({
            title: 'Error',
            content: err.message || 'Failed to send link. Please try again.',
          });
      });
  };

  render() {
    return (
      <div className="login-form">
        <img alt="" src={fulllogo} style={{ width: "200px" }} />
        <h2>Forgot Password</h2>
        <form onSubmit={this.handleSubmit}>
          <div className="login-items">
            <input
              type="email"
              placeholder="Enter your email"
              value={this.state.email}
              onChange={(e) => this.setState({ email: e.target.value })}
              required
              style={{width: "100%"}}
            />
          </div>
          <div className="login-items">
            <button
              className="btn btn-primary"
              style={{ width: "200px" }}
              type="submit"
              disabled={this.state.isSubmitting}
            >
              {this.state.isSubmitting ? "Sending..." : "Send Reset Link"}
            </button>
          </div>
          <div className="login-items">
            <Link to="/" style={{ fontSize: "0.9rem" }}>
              Login
            </Link>
          </div>
        </form>
      </div>
    );
  }
}

export default withRouter(ForgotPassword);